export { SunAlt as default } from './SunAlt';
